import { render, staticRenderFns } from "./order_assignment_methods.vue?vue&type=template&id=08de3616&scoped=true&"
import script from "./order_assignment_methods.vue?vue&type=script&lang=js&"
export * from "./order_assignment_methods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08de3616",
  null
  
)

export default component.exports